import { useContext } from 'react';

import AuthorizationContext from '../../../../src/packages/kakapo-ui-application/contexts/AuthorizationContext';

export function useAuthenticatedUser() {
	const { authenticatedUser } = useContext(AuthorizationContext)!;

	return authenticatedUser;
}
